<template>
  <screen-tab-filter-control label="Filter by Tags">
    <reference-tag-chip-selector
      v-if="hasAvailableTags"
      v-model="selectedTagsModel"
      :available-tags="availableTags"
      small
    />
    <span v-else class="grey--text text-body-2">
      No tags to filter by.
    </span>
  </screen-tab-filter-control>
</template>

<script>
import ReferenceTagChipSelector from '@/components/References/ReferenceTagChipSelector';
import ScreenTabFilterControl from './ScreenTabFilterControl';
import { typeHelpers } from '@/modules';
import { Tag } from '@/models';

export default {
  name: 'ScreenTabFilterByTagsControl',
  components: {
    ScreenTabFilterControl,
    ReferenceTagChipSelector,
  },
  props: {
    selectedTagIds: {
      type: Array,
      default: () => [],
    },
    availableTags: {
      type: Array,
      required: true,
      validator: (tags) => typeHelpers.isArrayOfType(tags, Tag),
    },
  },
  emits: ['update:selectedTagIds'],
  computed: {
    count() {
      return this.selectedTagIds.length;
    },
    hasAvailableTags() {
      return this.availableTags.length > 0;
    },
    selectedTagsModel: {
      get: function () {
        return (
          this.selectedTagIds?.map((id) =>
            this.availableTags.find((tag) => tag.id === id)
          ) || []
        );
      },
      set: function (value) {
        const newValues = value.map((tag) => tag.id);
        this.$emit(
          'update:selectedTagIds',
          newValues.length === 0 ? undefined : newValues
        );
      },
    },
  },
};
</script>
